/**
 * Key used to store monicore spans data in window
 */
export const MONICORE_SPANS = '_monicore_spans';
